
import {AntdConfig, AntdWidgets} from "@react-awesome-query-builder/antd";
import '@react-awesome-query-builder/ui/css/styles.css';
import {UseGet} from "../../../hooks/http";
import {Campaign} from "./widgets";
import {GetDefinition} from "./hooks";


const {FieldCascader, FieldSelect} = AntdWidgets;
const InitialConfig = AntdConfig;


export default ({fields}) => {


    const getStatus = async () => {

        const request = await UseGet(
            '/status/get',
            {toArray: true},
        )

        return {
            values : request,
            hasMore: false,
        }
    }


    const getDynamicFields = (target) => {
        const output = {}
        const excluded = ['id_action', 'id_journey', 'status', 'channel', 'id_campaign', 'id_component']
        if (typeof fields[target] === 'object' && Object.keys(fields[target]).length > 0) {
            Object.keys(fields[target]).map(property => {
                if (!excluded.includes(property)) {
                    output[property] = GetDefinition(fields[target][property])
                }
            })
        }

        return output;
    }


    const configFields = {
        History : {
            label    : "History Data",
            fieldName: "History",
            type     : "!struct",
            subfields: {
                fields     : {
                    label    : "Fields",
                    type     : "!struct",
                    subfields: {
                        ...getDynamicFields('history'),
                    }
                },
                status     : {
                    type         : "select",
                    label        : "Status",
                    valueSources : ["value"],
                    operators    : ['select_equals', 'select_not_equals'],
                    fieldSettings: {
                        asyncFetch       : getStatus,
                        useAsyncSearch   : true,
                        useLoadMore      : true,
                        forceAsyncSearch : false,
                        allowCustomValues: false
                    }
                },
            },
        },
        Audience: {
            label    : "Audience Data",
            fieldName: "Audience",
            type     : "!struct",
            subfields: {
                ...getDynamicFields('audience'),

            }
        }
    }


    return {
        ...InitialConfig,
        conjunctions: {
          AND: {
              ...InitialConfig.conjunctions.AND
          }
        },
        operators: {
            ...InitialConfig.operators,
            is_empty    : {
                ...InitialConfig.operators.is_empty,
                mongoFormatOp: (field, operator) => {
                    return {[field]: {$exists: false}}
                }
            },
            is_not_empty: {
                ...InitialConfig.operators.is_not_empty,
                mongoFormatOp: (field, operator) => {
                    return {[field]: {$exists: true}}
                }
            }
        },
        types    : {
            ...InitialConfig.types,
            campaign: {
                defaultOperator: "equal",
                valueSources   : ['value'],
                widgets        : {
                    campaign: {
                        operators  : [
                            "equal",
                            "not_equal",
                            "is_empty",
                            "is_not_empty",
                        ],
                        widgetProps: {
                            valueSources: ['value'],
                        },
                        opProps    : {
                            mainWidget: 'search',
                        }
                    },
                },
            },
        },
        widgets  : {
            ...InitialConfig.widgets,
            campaign: {
                type    : 'campaign',
                valueSrc: 'value',
                factory : (props) => (<Campaign {...props} />),
            },
        },
        settings : {
            ...InitialConfig.settings,
            renderField                : (props) => <FieldCascader {...props} />,
            renderOperator             : (props) => <FieldSelect {...props} />,
            renderFunc                 : (props) => <FieldSelect {...props} />,
            canReorder                 : true,
            canRegroup                 : true,
            maxNesting                 : 1,
            showLabels                 : false,
            showNot                    : false,
            showCombinatorsBetweenRules: false,
            setOpOnChangeField         : ['keep', 'default'],
            customFieldSelectProps     : {
                showSearch: true
            },
        },
        fields   : configFields,
    };


};